import React, { useRef, useEffect, useState, ReactNode } from 'react'
import { useRouter } from 'next/navigation'
import styles from './SearchPopup.module.scss'
import Image from 'next/image'
import SearchIcon from '@/public/assets/images/search_white_icon.svg'

interface Props {
  onClose: () => void
}

const SearchPopup: React.FC<Props> = ({ onClose }) => {
  const [search, setSearch] = useState('')
  const router = useRouter()
  const popupRef = useRef<HTMLDivElement>(null)

  // Close on click outside
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(e.target as Node)) {
        onClose()
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [onClose])

  // Handler for submit
  const handleSearch = () => {
    if (search.trim()) {
      router.push(`/search/${search}?page=1`)
      onClose()
    }
  }

  // Handle Enter key
  const handleKeyDown: React.KeyboardEventHandler<HTMLInputElement> = (e) => {
    if (e.key === 'Enter') handleSearch()
  }

  return (
    <BackDrop>
      <div ref={popupRef} className={`${styles.searchDiv} font-dm-mono `}>
        <input
          type="text"
          placeholder="Search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyDown={handleKeyDown}
          className={styles.searchInput}
          autoFocus
        />
        <Image src={SearchIcon} alt="Search" className="cursor-pointer" onClick={handleSearch} />
      </div>
    </BackDrop>
  )
}

export default SearchPopup

const BackDrop = ({ children }: { children: ReactNode }) => {
  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-[4px] z-[9999] flex items-center justify-center">
      {children}
    </div>
  )
}
